export const AccountUpdatedWalletClearedMessage = {
  headerText: 'ACCOUNT UPDATED',
  text: 'CHANGES SAVED',
  subText:
    "For security reasons, any credit card information has been removed from your account. You can add payment methods in the 'Account' section.",
  okText: 'GOT IT',
  hideCancel: true,
}
